
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/komodo-defi-framework/api/v20-dev/wc_delete_session",
      function () {
        return require("private-next-pages/docs/komodo-defi-framework/api/v20-dev/wc_delete_session/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/komodo-defi-framework/api/v20-dev/wc_delete_session"])
      });
    }
  